import React from "react";
import { Checkbox as EtCheckbox, CheckboxVariant } from "@ever-tutor/et-ui";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  showIcon?: boolean;
  variant?: CheckboxVariant;
  "aria-label"?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  children,
  disabled = false,
  className = "",
  labelClassName = "",
  variant = CheckboxVariant.DEFAULT,
  "aria-label": ariaLabel,
}) => {
  return (
    <EtCheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={className}
      labelClassName={labelClassName}
      variant={variant}
      aria-label={
        ariaLabel ?? (typeof children === "string" ? children : "Checkbox")
      }
    >
      {children}
    </EtCheckbox>
  );
};

export default Checkbox;
